import { html, TemplateResult } from "lit";
import { DownloadType } from "../../../common/utils/downloader/interfaces/downloader.interface";
import { dateString } from "../../product-catalog-download/utils/downloader.util";
import { WishList } from "../interfaces/wish-list-items.interface";

export const PDF_MAP = {
  "pdf": DownloadType.PDF,
  "csv": DownloadType.CSV,
  "xlsx": DownloadType.XLSX,
}

export const downloadTypes: DownloadType[] = [DownloadType.PDF, DownloadType.CSV, DownloadType.XLSX];
export const csvXlsxHeaders: string[] = ['Title', 'Grade', 'MHID', 'ISBN13', 'Price', 'Comments', 'User Name'];
export const productFields: string[] = ['title', 'gradeLevels', 'mhid', 'isbn13', 'totalPrice', 'comments', 'userName'];
export const wishListItemPdfHeader = (wishList: WishList): TemplateResult => html`<span><strong>${wishList?.name}</strong> - ${dateString}</span>`;
